import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateService } from '../../date.service';

@Component({
  selector: 'app-calendar-nav',
  templateUrl: './calendar-nav.component.html',
  styleUrls: ['./calendar-nav.component.scss'],
})
export class CalendarNavComponent {
  @Output() currentDateChange = new EventEmitter<Date>();

  @Input()
  set currentDate(currentDate: Date) {
    this.form.setValue(currentDate);
  }

  form: FormControl;
  @Input() isShowNextPrevBtn: boolean = true;
  @Input() color?: string | null = null;

  constructor(
    public dateService: DateService
  ) {
    this.form = new FormControl();
    this.color = this.color ?? "var(--kids-blue)";
  }

  onChange(): void {
    this.currentDateChange.emit(this.form.value);
  }

  prevClick(): void {
    const d = new Date(this.form.value);
    d.setDate(d.getDate() - 1);
    this.form.setValue(d, { emitEvent: false });
    this.currentDateChange.emit(d);
  }

  nextClick(): void {
    const d = new Date(this.form.value);
    d.setDate(d.getDate() + 1);
    this.form.setValue(d, { emitEvent: false });
    this.currentDateChange.emit(d);
  }
}
